/*
  Locks Rebuy's native discount disclosure for URL discounts without hiding
  the applied tag or its amount. Rebuy owns tag removal; this manager only
  clears Shopify's URL cookie after that tag has disappeared from the DOM.
*/

window.URLDiscountManager = (function () {
  const LOCKED_LABEL = 'CODE PROMO APPLIQUÉ !';
  let debug = false;
  let observer = null;
  let pendingURLTagRemoval = false;
  let removalTimer = null;

  function log(...args) {
    if (debug) console.log('[URLDiscountManager]', ...args);
  }

  function getURLDiscountCode() {
    const cookie = document.cookie
      .split(';')
      .find(value => value.trim().startsWith('discount_code='));
    if (!cookie) return null;

    const code = decodeURIComponent(cookie.split('=').slice(1).join('='));
    return code && code !== 'undefined' ? code.trim().toUpperCase() : null;
  }

  function hasURLDiscount() {
    return Boolean(getURLDiscountCode());
  }

  function getURLDiscountTag() {
    const code = getURLDiscountCode();
    if (!code) return null;

    return Array.from(document.querySelectorAll('.rebuy-cart__discount-tag')).find(tag =>
      tag.textContent.toUpperCase().includes(code)
    );
  }

  function clearURLDiscountCookie() {
    document.cookie = 'discount_code=; path=/; max-age=0; SameSite=Lax';
    pendingURLTagRemoval = false;
    log('Cleared URL discount cookie after native tag removal');
  }

  function restoreDisclosure(wrapper) {
    const disclosure = wrapper.querySelector('.rebuy-cart__discount-disclosure');
    if (!disclosure) return;

    wrapper.classList.remove('bwb-url-discount-locked');
    const label = disclosure.querySelector('.rebuy-cart__discount-summary-label');
    const arrow = disclosure.querySelector('.rebuy-cart__discount-summary-arrow');
    const form = disclosure.querySelector('.rebuy-cart__discount-form');

    if (label?.dataset.bwbOriginalLabel) {
      label.textContent = label.dataset.bwbOriginalLabel;
      delete label.dataset.bwbOriginalLabel;
    }
    arrow?.style.removeProperty('display');
    form?.style.removeProperty('display');
    disclosure.removeAttribute('data-bwb-url-discount-locked');
  }

  function lockDisclosure(wrapper) {
    const disclosure = wrapper.querySelector('.rebuy-cart__discount-disclosure');
    if (!disclosure) {
      log('Native Rebuy discount disclosure is not available yet');
      return;
    }

    const label = disclosure.querySelector('.rebuy-cart__discount-summary-label');
    const arrow = disclosure.querySelector('.rebuy-cart__discount-summary-arrow');
    const form = disclosure.querySelector('.rebuy-cart__discount-form');

    wrapper.classList.add('bwb-url-discount-locked');
    disclosure.dataset.bwbUrlDiscountLocked = 'true';
    disclosure.open = false;

    if (label) {
      if (!label.dataset.bwbOriginalLabel) label.dataset.bwbOriginalLabel = label.textContent;
      if (label.textContent !== LOCKED_LABEL) label.textContent = LOCKED_LABEL;
    }
    arrow?.style.setProperty('display', 'none', 'important');
    form?.style.setProperty('display', 'none', 'important');

    if (!disclosure.dataset.bwbLockListener) {
      disclosure.addEventListener(
        'click',
        event => {
          if (disclosure.dataset.bwbUrlDiscountLocked === 'true') {
            event.preventDefault();
            disclosure.open = false;
          }
        },
        true
      );
      disclosure.dataset.bwbLockListener = 'true';
    }
  }

  function settleNativeTagRemoval() {
    if (!pendingURLTagRemoval || getURLDiscountTag()) return;

    window.clearTimeout(removalTimer);
    removalTimer = window.setTimeout(() => {
      if (pendingURLTagRemoval && !getURLDiscountTag()) {
        clearURLDiscountCookie();
        manageDiscountInput();
      }
    }, 0);
  }

  function manageDiscountInput() {
    const wrapper = document.querySelector('[data-rebuy-component="discount-input"]');
    if (!wrapper) return;

    if (hasURLDiscount()) {
      lockDisclosure(wrapper);
      settleNativeTagRemoval();
    } else {
      restoreDisclosure(wrapper);
      pendingURLTagRemoval = false;
    }
  }

  function observeRebuyRedraws() {
    if (observer) return;

    observer = new MutationObserver(() => manageDiscountInput());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function handleDiscountTagClick(event) {
    const removeButton = event.target.closest('.rebuy-cart__discount-tag-remove');
    if (!removeButton) return;

    const tag = removeButton.closest('.rebuy-cart__discount-tag');
    const urlTag = getURLDiscountTag();
    if (tag && urlTag && tag === urlTag) {
      pendingURLTagRemoval = true;
      log('Waiting for native URL tag removal before clearing cookie');
    }
  }

  return {
    init: function () {
      if (!window.RebuyEventManager) {
        console.error('[URLDiscountManager] RebuyEventManager not available');
        return this;
      }

      window.RebuyEventManager.on('cart:show', manageDiscountInput)
        .on('cart:change', manageDiscountInput)
        .on('cart:ready', manageDiscountInput)
        .on('discount:applied', manageDiscountInput)
        .on('discount:removed', manageDiscountInput);

      document.addEventListener('click', handleDiscountTagClick);
      window.addEventListener('pageshow', manageDiscountInput);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') manageDiscountInput();
      });

      observeRebuyRedraws();
      manageDiscountInput();
      return this;
    },

    refresh: function () {
      manageDiscountInput();
      return this;
    },

    debug: function (enabled) {
      debug = enabled;
      return this;
    },
  };
})();
